export const ConsentStatus = {
    CONSENTED: 'CONSENTED',
    DID_NOT_CONSENT: 'DID_NOT_CONSENT',
    UNKNOWN: 'UNKNOWN',
};

export type TConsentStatus = typeof ConsentStatus[keyof typeof ConsentStatus];
